import { ReactNode } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { keycloak } from '@/shared/lib/keycloack/init';
import { detectEnv } from '@/shared/lib/detectEnv/detectEnv';

interface IKeycloackProvider {
    children: ReactNode;
}

const KeycloackProvider = (props: IKeycloackProvider) => {
    const { children } = props;
    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                redirectUri: `${window.location.origin}/ipoteka/auth`,
                onLoad: 'check-sso',
                checkLoginIframe: false,
            }}
            onEvent={(event, error) => {
                if (event === 'onAuthSuccess') {
                    // Keycloak authentication successful
                }
                if (event === 'onAuthError') {
                    // Keycloak authentication error - предотвращаем автоматический редирект
                    // Ошибка login_required - это нормально, когда пользователь не авторизован
                    if (error && error.error !== 'login_required') {
                        // Обрабатываем только критические ошибки
                    }
                }
                if (event === 'onTokenExpired') {
                    // Токен истек - не редиректим автоматически
                }
            }}
        >
            {children}
        </ReactKeycloakProvider>
    );
};

export default KeycloackProvider;
